import React from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { css } from "aphrodite";
import moment from "moment";
import { colorMaps } from "../../lib/utils";
import styles from "./style";
import PopupContent from "./PopupContent";

const DiaryRow = (props) => {
  let diaryColorMap = colorMaps.diary;
  let rowContent = [];
  let rt = Object.keys(props.dataObj);
  //console.log("rt...",rt)
  if (rt.length === 0) {
    return <tbody></tbody>;
  }
  let rowTypes = rowTypeSequence["Hemophilia"].filter(function (s) {
    return rt.indexOf(s) !== -1;
  });
  rowTypes.forEach((rowType, index) => {
    let rowCells = [];
    rowCells.push(
      <td key={`${rowType}_${index}__key`} style={{ textAlign: "center" }} />
    );
    let dateWiseData = props.dataObj[rowType];
    if (dateWiseData !== undefined) {
      dateWiseData.forEach((rowTypeObj, rowTypeIndex) => {
        //let rowTypeObj = props.dataObj[rowType][date];
        let date = rowTypeObj.timestamp;
        //let dt = date;
        let imgBgColor =
          diaryColorMap[rowType] !== undefined
            ? diaryColorMap[rowType]
            : "#C90000";

        let rowClassObj =
          props.selectedDate !== 0
            ? moment
                .unix(props.selectedDate)
                .isSame(moment.unix(date / 1000).startOf("day"))
              ? styles.selectedRow
              : ""
            : "";
        rowCells.push(
          <td
            key={`${rowType}__${date}__${index}__${rowTypeIndex}`}
            className={css([rowClassObj])}
            style={{ textAlign: "center" }}
          >
            {rowTypeObj.reported ? (
              <OverlayTrigger
                show={
                  (props.selectedDate !== 0 && props.selectedRowType === rowType
                    ? moment
                        .unix(props.selectedDate)
                        .startOf("day")
                        .isSame(moment.unix(date / 1000).startOf("day"))
                    : false) && props.popupIsOpen
                }
                onToggle={() => props.handleOpenPopup(rowType, date)}
                trigger="click"
                placement="auto"
                overlay={
                  <PopupContent
                    rowType={rowType}
                    data={rowTypeObj.data}
                    show={props.popupIsOpen}
                    date={date}
                    type={rowTypeObj.type}
                    showDetails={() => props.showDetails(date)}
                  />
                }
              >
                <span style={{ verticalAlign: "middle" }}>
                  {rowType === "reminders" ? (
                    <img
                      src={
                        rowTypeObj.takenFlag
                          ? "/images/diary/" + rowType + "_event_icon_taken.png"
                          : "/images/diary/" +
                            rowType +
                            "_event_icon_nottaken.png"
                      }
                      alt={rowType}
                      className={css([
                        styles.iconOpacity,
                        styles.timelineIconBgWithoutPadding,
                      ])}
                      style={{
                        backgroundColor: imgBgColor,
                        cursor: "pointer",
                      }}
                    />
                  ) : (
                    <img
                      src={"/images/diary/" + rowType + "_event_icon.png"}
                      alt={rowType}
                      className={css([
                        styles.iconOpacity,
                        styles.timelineIconBgWithoutPadding,
                      ])}
                      style={{
                        backgroundColor: imgBgColor,
                        cursor: "pointer",
                      }}
                    />
                  )}
                </span>
              </OverlayTrigger>
            ) : (
              <span
                style={{
                  verticalAlign: "middle",
                }}
              />
            )}
          </td>
        );
      });
      /**
       * If the date count is less than 30 days then fill the table rows with
       * empty cells to make the view look better.
       */
      if (dateWiseData.length < 30) {
        let emptyCellCount = 30 - dateWiseData.length;
        for (let dIdx = 0; dIdx < emptyCellCount; dIdx++) {
          rowCells.push(
            <td
              key={`${rowType}__${index}_empty_${dIdx}`}
              style={{ textAlign: "center" }}
            />
          );
        }
      }
    }
    rowCells.push(<td key={`${rowType}__${index}`} />);
    let rowBgColor = index % 2 === 0 ? "#FFF" : "#F4F4F4";
    rowContent.push(
      <tr
        style={{
          backgroundImage: "url(/images/diary/" + rowType + "_bgicon_row.png)",
          backgroundSize: "50px 65px",
          backgroundRepeat: "no-repeat",
          height: "70px",
          backgroundColor: rowBgColor,
          border: "0px solid white",
        }}
        key={rowType + "_" + index}
      >
        {rowCells}
      </tr>
    );
  });

  return <tbody>{rowContent}</tbody>;
};

const rowTypeSequence = {
  Hemophilia: [
    //"bleeds",
    "reminders",
    "visits",
    "help",
    "symptoms",
    "weightlogs",
    //"treatmentLogs",
    "abnormalMotion",
    "allergy",
    "heightlogs",
    "hrmLogs"
  ],
  MS: ["bleeds", "reminders", "visits", "help", "symptoms", "walks"],
};

export default DiaryRow;
